import APIClient from '@/shared/http/clients/api'

const resourceName = 'city'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetAllByStateID = (stateid, config = {}) => APIClient.get(`${APICore}/${resourceName}/state/${stateid}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)

const CityRepository = {
  GetAll,
  GetAllPaging,
  GetAllByStateID,
  GetById
}

export default CityRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/geo/city.js